import React from 'react';
import { Box } from '@mui/material';
import sureSpaceLogo from '../../assets/logo.png';
import { usePortalTokens } from '../../styles/usePortalTokens';

const SidebarBrand = () => {
  const portal = usePortalTokens();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', px: '24px', pb: '28px' }}>
      <Box
        component="img"
        src={sureSpaceLogo}
        alt=""
        sx={{ width: 28, height: 28, objectFit: 'contain', display: 'block', flexShrink: 0 }}
      />
      <Box
        component="span"
        sx={{
          fontSize: 19,
          fontWeight: 800,
          color: portal.text,
          letterSpacing: '0.3px',
          lineHeight: 1,
        }}
      >
        SURE
        <Box component="span" sx={{ color: portal.accent }}>
          SPACE
        </Box>
      </Box>
    </Box>
  );
};

export default SidebarBrand;
